module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/day01_01_stay-b2a43b02ca6dc555d0141d0c384e4e1b.jpg";